(function() {
  function getPriceText(block) {
    var priceElement = block.querySelector('.price-element');
    if (!priceElement) return null;
    var rawPrice = priceElement.getAttribute('data-price');
    var numericPrice = Number(rawPrice);
    if (!Number.isFinite(numericPrice)) return null;
    return '$' + numericPrice.toFixed(2) + ' USD';
  }

  function getMainPriceTarget(block) {
    var productInfo = block.closest('.t4s-product__info-container') || document;
    return productInfo.querySelector('.t4s-product__price-review .t4s-product-price ins .trans-money') ||
      productInfo.querySelector('.t4s-product__price-review .t4s-product-price ins') ||
      productInfo.querySelector('.t4s-product__price-review .t4s-product-price .trans-money') ||
      document.querySelector('.t4s-product__price-review .t4s-product-price ins .trans-money') ||
      document.querySelector('.t4s-product__price-review .t4s-product-price ins') ||
      document.querySelector('.t4s-product__price-review .t4s-product-price .trans-money');
  }

  function syncMainPrice(block) {
    var priceText = getPriceText(block);
    var target = getMainPriceTarget(block);
    if (priceText && target) target.textContent = priceText;
  }

  function setQuantity(block) {
    var priceElement = block.querySelector('.price-element');
    var quantity = priceElement ? priceElement.getAttribute('data-quantity') : null;
    if (!quantity) return;
    var quantityInput = document.querySelector('.t4s-quantity-input');
    if (!quantityInput) return;
    quantityInput.value = quantity;
    quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function initWholesaleSwitch() {
    var wholesaleSwitch = document.querySelectorAll('.tiered-discount-block');
    if (!wholesaleSwitch.length) return;

    wholesaleSwitch.forEach(function(switchBlock) {
      switchBlock.addEventListener('click', function() {
        wholesaleSwitch.forEach(function(block) {
          block.classList.remove('tiered-discount-block--active');
        });
        this.classList.add('tiered-discount-block--active');
        setQuantity(this);
        syncMainPrice(this);
        window.setTimeout(syncMainPrice.bind(null, this), 50);
      });
    });
  }

  function formatProductTotal(cents, total) {
    var currency = total.getAttribute('data-currency') || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency
      }).format(cents / 100);
    } catch (error) {
      return (cents / 100).toFixed(2) + ' ' + currency;
    }
  }

  function getTierForQuantity(buttons, quantity) {
    if (!buttons) return null;
    var matched = null;
    var matchedMinimum = -1;
    buttons.querySelectorAll('.tiered-discount-block .price-element[data-quantity][data-price]').forEach(function(priceElement) {
      var minimum = Number(priceElement.getAttribute('data-quantity'));
      if (!Number.isFinite(minimum) || minimum > quantity || minimum < matchedMinimum) return;
      matched = priceElement.closest('.tiered-discount-block');
      matchedMinimum = minimum;
    });
    return matched;
  }

  function updateProductTotal(total, variantPrice) {
    if (!total) return;
    if (Number.isFinite(Number(variantPrice))) {
      total.setAttribute('data-unit-price', String(variantPrice));
    }
    var form = total.closest('form');
    var buttons = total.closest('.t4s-product-form__buttons');
    var quantityInput = buttons && buttons.querySelector('[data-quantity-value][name="quantity"]');
    if (!quantityInput && form) quantityInput = form.querySelector('[name="quantity"]');
    var quantity = quantityInput ? Number(quantityInput.value) : 1;
    var unitPrice = Number(total.getAttribute('data-unit-price'));
    if (!Number.isFinite(quantity) || quantity < 0 || !Number.isFinite(unitPrice)) return;
    var activeTier = getTierForQuantity(buttons, quantity);
    if (activeTier) {
      var tierPrice = Number(activeTier.querySelector('.price-element').getAttribute('data-price'));
      if (Number.isFinite(tierPrice)) unitPrice = Math.round(tierPrice * 100);
    }
    if (buttons) {
      buttons.querySelectorAll('.tiered-discount-block').forEach(function(block) {
        block.classList.toggle('tiered-discount-block--active', block === activeTier);
      });
    }
    var value = total.querySelector('[data-ovoin-product-total-value]');
    if (value) value.textContent = formatProductTotal(Math.round(unitPrice * quantity), total);
  }

  function updateTotalsForVariant(variant) {
    if (!variant || !Number.isFinite(Number(variant.price))) return;
    document.querySelectorAll('[data-ovoin-product-total]').forEach(function(total) {
      var productId = Number(total.getAttribute('data-product-id'));
      if (variant.product_id && Number(variant.product_id) !== productId) return;
      updateProductTotal(total, variant.price);
    });
  }

  function initProductTotals() {
    document.querySelectorAll('[data-ovoin-product-total]').forEach(function(total) {
      if (total.dataset.ovoinTotalReady === 'true') return;
      total.dataset.ovoinTotalReady = 'true';
      var form = total.closest('form');
      if (!form) return;

      form.addEventListener('input', function(event) {
        if (event.target.matches('[name="quantity"]')) updateProductTotal(total);
      });
      form.addEventListener('change', function(event) {
        if (event.target.matches('[name="quantity"]')) updateProductTotal(total);
      });
      form.addEventListener('click', function(event) {
        if (!event.target.closest('[data-quantity-selector]')) return;
        window.setTimeout(function() { updateProductTotal(total); }, 0);
      });
      updateProductTotal(total);
    });

    if (document.documentElement.dataset.ovoinTotalVariantEvent !== 'true') {
      document.documentElement.dataset.ovoinTotalVariantEvent = 'true';
      document.addEventListener('variant:changed', function(event) {
        updateTotalsForVariant(event.currentVariant || (event.detail && (event.detail.currentVariant || event.detail.variant)));
      });
      if (window.jQuery_T4NT) {
        jQuery_T4NT(document).on('variant:changed.ovoinProductTotal', function(event) {
          updateTotalsForVariant(event.currentVariant);
        });
      }
    }
  }

  function initShareButtons() {
    document.querySelectorAll('[data-ovoin-share]').forEach(function(button) {
      if (button.dataset.ovoinShareReady === 'true') return;
      button.dataset.ovoinShareReady = 'true';
      button.addEventListener('click', function(event) {
        event.preventDefault();
        event.stopPropagation();
        var wrapper = this.closest('[data-ovoin-share-wrap]');
        var shouldOpen = !wrapper.classList.contains('is-open');
        document.querySelectorAll('[data-ovoin-share-wrap].is-open').forEach(function(openWrapper) {
          openWrapper.classList.remove('is-open');
          var openButton = openWrapper.querySelector('[data-ovoin-share]');
          if (openButton) openButton.setAttribute('aria-expanded', 'false');
        });
        wrapper.classList.toggle('is-open', shouldOpen);
        this.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
      });
    });

    if (document.documentElement.dataset.ovoinShareEvents !== 'true') {
      document.documentElement.dataset.ovoinShareEvents = 'true';
      document.addEventListener('click', function(event) {
        if (event.target.closest('[data-ovoin-share-wrap]')) return;
        document.querySelectorAll('[data-ovoin-share-wrap].is-open').forEach(function(wrapper) {
          wrapper.classList.remove('is-open');
          var button = wrapper.querySelector('[data-ovoin-share]');
          if (button) button.setAttribute('aria-expanded', 'false');
        });
      });
      document.addEventListener('keydown', function(event) {
        if (event.key !== 'Escape') return;
        document.querySelectorAll('[data-ovoin-share-wrap].is-open').forEach(function(wrapper) {
          wrapper.classList.remove('is-open');
          var button = wrapper.querySelector('[data-ovoin-share]');
          if (button) {
            button.setAttribute('aria-expanded', 'false');
            button.focus();
          }
        });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initWholesaleSwitch();
      initProductTotals();
      initShareButtons();
    });
  } else {
    initWholesaleSwitch();
    initProductTotals();
    initShareButtons();
  }
}());
